
import { TapAnimation } from './TapAnimation';
import { Button } from '@cc/pixi-app';

export class ButtonBase extends Button {
    constructor(texture) {
        super(texture);
        // this.setAnimator(new TapAnimation());
        this._addListeners();
    }

    _addListeners() {
        this.on("touchstart", this._onTouchStart, this);
        this.on("touchend", this._onMouseOut, this);
        this.on("mouseout", this._onMouseOut, this);
        this.on("mouseover", this._onMouseOver, this);
        this.on("pointertap", this._onClick, this);
    }

    removeAllListeners() {
        super.removeAllListeners();
        this._addListeners();
    }

    _onMouseOver(e) {
        // if (!createjs.Tween.hasActiveTweens(this.sprite))
            this.scale.set(1.08);
    }

    _onMouseOut(e) {
        // if (!createjs.Tween.hasActiveTweens(this.sprite))
        this.scale.set(1);
    }

    _onTouchStart(e) {
        if (!createjs.Tween.hasActiveTweens(this.sprite))
            this.scale.set(1.05);
    }

    _onTouchEnd(e) {
        this.removeAllListeners();
    }

    _onClick() {
        // this.removeAllListeners();
        // this._addListeners();
    }
}

